export enum ManteinanceEmailSubject {
  rating = 'Edge Rating - System Maintenance',
  rateQuote = 'Edge Rate Quote - System Maintenance',
  ratingAnalysis = 'Edge Rating Analysis - System Maintenance',
}
